{
  "add_extra_cabin": "Extra hut toevoegen",
  "apply": "Toepassen",
  "availability": "Beschikbaarheid",
  "available_for_single_use": "Deze hut is boekbaar voor eenpersoons gebruik.",
  "button_title": {
    "add_person": "Persoon toevoegen aan de hut",
    "close_departure": "Vertrekblok inklappen",
    "open_departure": "Vertrekblok uitklappen",
    "remove_person": "Persoon verwijderen uit de hut"
  },
  "cabin_x": "Hut {{ count }}",
  "clear": "Wissen",
  "clear_filter": "Filters wissen",
  "close": "Sluiten",
  "date": "Datum",
  "departure": "Vertrek",
  "departure_statuses": {
    "available": "Beschikbaar",
    "fully_booked": "Volgeboekt",
    "on_request": "Op aanvraag",
    "only_x_left": "Nog maar {{ count }} beschikbaar"
  },
  "discount_amount": "–{{value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0)}}",
  "discount_percentage": "–{{value}}%",
  "filter_results": "Resultaten filteren",
  "filter_tours": "Reizen filteren",
  "format": {
    "date": "{{value, datetime(day: numeric; month: numeric; year: numeric)}}",
    "month": "{{value, datetime(month: long; year: numeric)}}",
    "price": "{{value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0)}}",
    "price_per_person": "{{value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0)}} p.p.",
    "weekday": "{{value, datetime(weekday: long)}}"
  },
  "fully_booked": {
    "after_one": "<0>{{count}} volgeboekte datum</0><1> gevonden na </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "after_other": "<0>{{count}} volgeboekte datums</0><1> gevonden na </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "before_one": "<0>{{count}} volgeboekte datum</0><1> gevonden vóór </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "before_other": "<0>{{count}} volgeboekte datums</0><1> gevonden vóór </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "between_one": "<0>{{count}} volgeboekte datum</0><1> gevonden tussen </1><2>{{afterDate, datetime(day: numeric; month: short; year: numeric)}}</2><3> & </3><4>{{beforeDate, datetime(day: numeric; month: short; year: numeric)}}</4>",
    "between_other": "<0>{{count}} volgeboekte datums</0><1> gevonden tussen </1><2>{{afterDate, datetime(day: numeric; month: short; year: numeric)}}</2><3> & </3><4>{{beforeDate, datetime(day: numeric; month: short; year: numeric)}}</4>",
    "only_one": "<0>{{count}} volgeboekte datum</0><1> gevonden</1>",
    "only_other": "<0>{{count}} volgeboekte datums</0><1> gevonden</1>"
  },
  "guaranteed": "Gegarandeerd",
  "guidance": "Begeleiding",
  "guidance_types": {
    "Guided": "Begeleid",
    "Independent": "Zelfstandig",
    "Semi-Guided": "Gedeeltelijk begeleid"
  },
  "load_more": "Meer laden",
  "load_more_dates": "Meer datums laden",
  "maximum_occupancy_x_one": "Max. {{ count }} persoon",
  "maximum_occupancy_x_other": "Max. {{ count }} personen",
  "only_x_left": "Nog maar {{ count }} beschikbaar",
  "persons": "Personen",
  "persons_in_cabins": "{{ persons }} in {{ cabins }}",
  "port_of_departure": "Vertrekhaven",
  "prices_from": "Prijs vanaf",
  "remove_cabin": "Hut verwijderen",
  "remove_x_cabins_one": "Hut verwijderen",
  "remove_x_cabins_other": "{{count}} hutten verwijderen",
  "select_available_cabins": "Beschikbare hutten selecteren",
  "select_this_cabin": "Deze hut selecteren",
  "sgr": "{{count}}x {{ value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0) }} SGR-bijdrage",
  "ship": "Schip",
  "show_x_tours_one": "{{ count }} reis tonen",
  "show_x_tours_other": "{{ count }} reizen tonen",
  "single_use_notice": "Bij gebruik van een hut door slechts één persoon geldt een toeslag voor eenpersoonsgebruik.",
  "sort_by": "Sorteren op",
  "sort_keys": {
    "price": "Prijs",
    "start_date": "Startdatum"
  },
  "start_booking": "Boeking starten",
  "start_date": "Startdatum",
  "tooltips": {
    "guaranteed": {
      "description": "Dit vertrek is gegarandeerd, ook als het minimumaantal passagiers niet is bereikt.",
      "title": "Wat betekent gegarandeerd?"
    },
    "on_request": {
      "description": "\"Op aanvraag\" betekent dat we de beschikbaarheid nog moeten controleren. We bevestigen uw boeking of stellen alternatieven voor binnen 48 uur.",
      "title": "Wat betekent op aanvraag?"
    }
  },
  "total_price": "Totaalprijs",
  "view_cabin": "Details bekijken",
  "view_ship": "Schip bekijken",
  "year": "Jaar",
  "x_cabins_one": "{{ count }} hut",
  "x_cabins_other": "{{ count }} hutten",
  "x_left": "{{ count }} beschikbaar",
  "x_person_cabin": "{{ count }}-persoonshut",
  "x_persons_one": "{{ count }} persoon",
  "x_persons_other": "{{ count }} personen",
  "x_to_y_person_cabin": "{{ min }}-tot-{{ max}}-persoonshut",
  "x_tours_one": "{{ count }} reis",
  "x_tours_other": "{{ count }} reizen"
}
